// ServerCard.js

import { Card } from "antd";
import styles from "./styles.module.scss"; // Assuming you have shared styles for the card

export function ServerCard({ data, lastPingCheck: pingDiff }: any) {
  const {
    cardNumber,
    color,
    serverStatus,
    serverName,
    currentStatus,
    runningSince,
    currentMemory,
    lastHealthCheck,
    lastActivity,
    filename,
    email,
    minProcessingTime,
    maxProcessingTime,
    averageProcessingTime,
  } = data;

  let middleSectionColor = ""; // Default color
  let statusIndicator = ""; // Default color
  let currentStatusColor = "";
  // Determine the middle section color based on server status
  if (serverStatus === "Connected") {
    middleSectionColor = "#EBF8ED";
    statusIndicator = "#16A665";
  } else if (serverStatus === "Starting") {
    middleSectionColor = "#FDF0C3";
    statusIndicator = "#F4BD00";
  } else if (serverStatus === "Disconnected") {
    middleSectionColor = "#F63E501A";
    statusIndicator = "#F63E50";
  }

  if (currentStatus === "Busy") {
    currentStatusColor = "#F63E50";
  } else if (currentStatus === "Available") {
    currentStatusColor = "#16A665";
  }

  if (pingDiff > 45) {
    statusIndicator = "#F63E50";
    middleSectionColor = "#F63E501A";
    currentStatusColor = "#F63E50";
  }

  return (
    <Card
      bordered={true}
      className={styles["serverCard"]}
      styles={{ body: { padding: "5px" } }}
    >
      <div className={styles["cardTitleContent"]}>
        <div className={styles["iconContainer"]}>
          <div
            style={{ backgroundColor: statusIndicator }}
            className={styles.serverContainer}
          >
            <img
              src="/assets/icons/serverIcon.svg"
              alt="Server Icon"
              className={styles["icon"]}
            />
          </div>
          <h4 className={styles["cardTitle"]}>Server Name: {serverName}</h4>
        </div>
        <div
          className={styles["statusButton"]}
          style={{ color: statusIndicator }}
        >
          <div
            className={styles["statusIndicator"]}
            style={{ backgroundColor: statusIndicator }}
          ></div>
          {pingDiff > 45 ? "Disconnected" : serverStatus}
        </div>
      </div>
      <div
        className={styles["cardMiddleSection"]}
        style={{ backgroundColor: middleSectionColor }}
      >
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/currentStatus.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>Current Status:</h4>
          </div>
          <div>
            <span
              className={styles["entryValue"]}
              style={{ color: currentStatusColor }}
            >
              {pingDiff > 45 ? "Busy" : currentStatus}
            </span>
          </div>
        </div>
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/runningSince.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>Running Since:</h4>
          </div>
          <div>
            <span className={styles["entryValue"]}>{runningSince}</span>
          </div>
        </div>
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/memory.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>
              {" "}
              Current GPU Memory Consumption:
            </h4>
          </div>
          <div>
            <span className={styles["entryValue"]}>{currentMemory}</span>
          </div>
        </div>
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/health.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>Last Health Check:</h4>
          </div>
          <div>
            <span className={styles["entryValue"]}>{lastHealthCheck}</span>
          </div>
        </div>
      </div>

      <div
        className={styles["cardMiddleSection"]}
        style={{ backgroundColor: middleSectionColor }}
      >
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/lastActivity.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>Last Activity:</h4>
          </div>
          <div>
            <span
              className={styles["entryValue"]}
              style={{ color: "rgb(246, 62, 80)" }}
            >
              {lastActivity}
            </span>
          </div>
        </div>
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/uploadedBy.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>Uploaded By:</h4>
          </div>
          <div>
            <span className={styles["entryValue"]}>{email}</span>
          </div>
        </div>
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/fileName.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>File Name:</h4>
          </div>
          <div>
            <span className={styles["entryValue"]}>{filename}</span>
          </div>
        </div>
      </div>

      <div
        className={styles["cardMiddleSection"]}
        style={{ backgroundColor: "#F0F0F0" }}
      >
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/maxProcessing.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>
              Maximum Processing Time:
            </h4>
          </div>
          <div>
            <span className={styles["entryValue"]}>{maxProcessingTime}</span>
          </div>
        </div>
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/avgProcessing.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>
              Average Processing Time:
            </h4>
          </div>
          <div>
            <span className={styles["entryValue"]}>
              {averageProcessingTime}
            </span>
          </div>
        </div>
        <div className={styles["entry"]}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ verticalAlign: "middle", display: "flex" }}>
              <img
                src="/assets/icons/minProcessing.svg"
                alt="Icon 1"
                className={styles["entryIcon"]}
              />
            </div>
            <h4 className={styles["entrySubheading"]}>
              Minimum Processing Time:
            </h4>
          </div>
          <div>
            <span className={styles["entryValue"]}>{minProcessingTime}</span>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <hr
          style={{
            borderColor: "#E0E0E0",
            opacity: "0.5",
            borderWidth: "0.5px",
          }}
        />
      </div>

      <div className={`${styles["entry"]} ${styles["bottomEntry"]}`}>
        <p className={styles["entrySubheading"]}>Server {cardNumber}</p>
      </div>
    </Card>
  );
}
